import { Linkedin, Youtube, ArrowUp } from "lucide-react";
import { scrollToSection } from "@/App";

const LINKS = [
  { label: "Course Catalog", id: "courses" },
  { label: "Consulting Services", id: "consulting" },
  { label: "Expertise Matrix", id: "expertise" },
  { label: "Alumni Reviews", id: "testimonials" },
  { label: "Blog", id: "blog" },
  { label: "Inquire / Enroll", id: "contact" },
];

const Footer = () => {
  return (
    <footer className="relative border-t border-slate-200 bg-[#F8FAFC]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-5">
          <div className="font-display font-extrabold tracking-tight text-2xl">VIKRAM FOTANI</div>
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-500 mt-2">
            SAP S/4HANA Transformation Leader
          </p>
          <div className="mt-6 flex flex-col gap-3">
            <a
              href="https://www.linkedin.com/in/vikram-fotani-525a42119/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-sky-700 transition-colors duration-300"
              data-testid="footer-linkedin-link"
            >
              <Linkedin size={15} /> linkedin.com/in/vikram-fotani
            </a>
            <a
              href="https://www.youtube.com/@VikramFotani"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-red-600 transition-colors duration-300"
              data-testid="footer-youtube-link"
            >
              <Youtube size={15} /> youtube.com/@VikramFotani
            </a>
          </div>
        </div>
        <div className="lg:col-span-4">
          <p className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-slate-500 mb-5">Navigate</p>
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                onClick={() => scrollToSection(l.id)}
                className="self-start text-sm text-slate-600 hover:text-amber-700 transition-colors duration-300"
                data-testid={`footer-link-${l.id}`}
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
        <div className="lg:col-span-3 flex lg:justify-end items-start">
          <button
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 }) || window.scrollTo({ top: 0, behavior: "smooth" })}
            className="flex items-center gap-2 border border-slate-200 rounded-full px-5 py-3 text-xs font-mono2 tracking-wider text-slate-600 hover:border-amber-400/50 hover:text-amber-700 transition-colors duration-300"
            data-testid="footer-back-to-top"
          >
            Back to top <ArrowUp size={13} />
          </button>
        </div>
      </div>
      <div className="border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 text-[11px] text-slate-500 leading-relaxed">
          © 2026 Vikram Fotani. All rights reserved. SAP and SAP S/4HANA are registered trademarks of SAP SE.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
